import { Box, useTheme } from '@mui/material';
import { t } from 'i18next';
import React from 'react';

import Button from '../../././Button';
import CardDivider from '../../Card/CardDivider';
import Markdown from '../../Markdown';
import { InputRenderer } from '../types';

import DefaultInput from './DefaultInput';
import MarkdownInstructions from './RichTextInput/MarkdownInstructions';

const RichTextInput = (props: InputRenderer) => {
  const [showPreview, setShowPreview] = React.useState(false);
  const theme = useTheme();

  return (
    <Box>
      <Box
        sx={{
          '& textarea': {
            fontFamily: theme.typography.fontFamily,
            overflow: 'hidden',
          },
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <DefaultInput {...props} multiline />
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
          }}
        >
          <Button
            small
            icon={showPreview ? 'caret-down' : 'caret-right'}
            variant="text"
            onClick={() => setShowPreview(!showPreview)}
          >
            {t('markdown.preview')}
          </Button>
          <MarkdownInstructions />
        </Box>
      </Box>
      {showPreview && (
        <div>
          <CardDivider />
          <Box
            sx={{
              padding: '10px 20px',
            }}
          >
            <Markdown text={props.inputProps.value} />
          </Box>
          <CardDivider />
        </div>
      )}
    </Box>
  );
};

export default RichTextInput;
